<template>
    <div class="canaux-connectes">
      <h2>Canaux connectés</h2>
      <p>Configurez les canaux par lesquels votre agent peut interagir avec vos utilisateurs.</p>
  
      <div class="canal" v-for="canal in canaux" :key="canal.nom">
        <h3>{{ canal.nom }}</h3>
        <p>{{ canal.description }}</p>
        <label>
          <input type="checkbox" v-model="canal.actif" /> Activer
        </label>
        <div v-if="canal.actif" class="config">
          <label>Clé API / Token :</label>
          <input type="text" v-model="canal.token" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Cookies from 'js-cookie'

  export default {
    name: "CanauxConnectes",
    mounted () {
      const token = Cookies.get('token')
      if (!token) return this.$router.push('/sign-in')
    },
    data() {
      return {
        canaux: [
          {
            nom: "Site Web",
            description: "Ajoutez l'agent sur votre site internet avec un script d'intégration.",
            actif: true,
            token: ""
          },
          {
            nom: "Instagram",
            description: "Répondez automatiquement aux messages privés.",
            actif: false,
            token: ""
          },
          {
            nom: "WhatsApp",
            description: "Automatisez les conversations sur WhatsApp Business.",
            actif: false,
            token: ""
          },
          {
            nom: "Messenger",
            description: "Connectez Facebook Messenger à votre agent.",
            actif: false,
            token: ""
          },
          {
            nom: "Telegram",
            description: "Répondez automatiquement sur Telegram.",
            actif: false,
            token: ""
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .canaux-connectes {
    max-width: 800px;
    margin: 0 auto;
  }
  
  h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  
  .canal {
    background: #fff;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }
  
  .canal h3 {
    font-size: 1.25rem;
    margin-bottom: 0.25rem;
  }
  
  .config {
    margin-top: 0.5rem;
  }
  
  input[type="text"] {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  </style>